import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import type { BlockEditProps } from '@plone/types';
import config from '@plone/registry';
import { BlockDataForm, SidebarPortal } from '@plone/volto/components';

import styles from './styles.module.css';
import type { BowlingCenterCarouselData } from './schema';
import type { BowlingCenterContent } from '../BowlingCenterDescription/schema';
import Body from './Body';

export type BowlingCenterCarouselEditProps = BlockEditProps & {
  data: BowlingCenterCarouselData;
  content: BowlingCenterContent;
};

const Edit = (props: BowlingCenterCarouselEditProps) => {
  const intl = useIntl();
  const { data, blocksConfig, onChangeBlock, block, selected } = props;
  const Container = config.getComponent('Container').component || 'div';

  const schema = blocksConfig[data['@type']].blockSchema({
    data,
    intl,
  });

  return (
    <>
      <section className={cx('block-bowlingcenter-carousel', styles.block)}>
        {!data?.styles?.fullwidth ? (
          <Container
            className={cx(
              'block-bowlingcenter-carousel-container',
              styles.container,
            )}
          >
            <Body data={data} {...props} />
          </Container>
        ) : (
          <div className="block-bowlingcenter-carousel">
            <Body data={data} {...props} />
          </div>
        )}
      </section>
      {/* @ts-expect-error */}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
